export type CoreFieldMaps = Record<string, string[] | null>;
// Additional fields carry their own transforms so they travel with the row
// through renames/removal — no name-keyed bookkeeping (names are mutable and
// can collide, so they make unsafe map keys).
export type AdditionalField = { name: string; path: string; transforms?: Transform[] };
export type Condition = { field: string; op: string; value: string };

// ── Per-field transforms ──
// A transform is a small jq operation applied to a mapped field's value
// (e.g. tonumber, epoch→ISO). Core-field transforms are stored in a side-map
// keyed like CoreFieldMaps (spec keys are stable, incl. "location.lat"/
// "location.lon"); additional-field transforms live on the AdditionalField
// itself. See genJq / applyTransforms.
export type TransformKind =
    | "tonumber"
    | "tostring"
    | "epoch_iso_s"
    | "epoch_iso_ms"
    | "divide"
    | "split"
    | "default"
    | "value_map"
    | "coalesce";

export type ValueMapPair = { from: string; to: string };

export type Transform = {
    kind: TransformKind;
    // Scalar argument: divisor (divide), delimiter (split), literal (default),
    // or a dotted source path (coalesce).
    arg?: string;
    // from→to pairs for value_map.
    pairs?: ValueMapPair[];
};

export type TransformMap = Record<string, Transform[]>;

export type ParseResult = {
    maps: CoreFieldMaps;
    conds: Condition[];
    addl: AdditionalField[];
    complexFields: Record<string, string>;
    transforms: TransformMap;
    isFullyParseable: boolean;
    rawJq: string;
};

export const OPS = [
    { v: "not_null", labelKey: "is not null" },
    { v: "is_null", labelKey: "is null" },
    { v: "equals", labelKey: "equals" },
    { v: "not_equals", labelKey: "≠" },
    { v: "gt", labelKey: ">" },
    { v: "lt", labelKey: "<" },
    { v: "contains", labelKey: "contains" },
];
